"use strict";
/**
 * @deprecated
 * 此文件不再继续使用和维护
 * 使用NetworkHelp代替
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.FullTokenAuthHeaderObservable = exports.AccessAndTraderAuthHeaderObservable = exports.AccessAndSpotAuthHeaderObservable = exports.processAccessNetworkHeader = exports.AccessAuthHeaderObservable = void 0;
const rxjs_1 = require("rxjs");
const operators_1 = require("rxjs/operators");
const dataRetrive_1 = require("../dataRetrive");
const Error_1 = require("../error/Error");
const Tools_1 = require("./Tools");
/**
 * @deprecated
 * 使用NetworkHelp代替
 */
const AccessAuthHeaderObservable = (headers, withBearer = true) => {
    return (0, dataRetrive_1.getTradeDependencyInstance)()
        .getAccessToken()
        .pipe((0, operators_1.map)((accessToken) => {
        if (!accessToken) {
            throw Error_1.ErrorGenerate.generateError(Tools_1.TradeHttpErrorCode.TradeUnAuthorized, "access UnAuthorized");
        }
        const header = Object.assign(Object.assign({}, headers), { Authorization: withBearer ? `Bearer ${accessToken}` : accessToken, "Content-Type": "application/json;charset=UTF-8" });
        return header;
    }));
};
exports.AccessAuthHeaderObservable = AccessAuthHeaderObservable;
/**
 * @deprecated
 * 使用NetworkHelp代替
 */
const processAccessNetworkHeader = (isAuth, headers, withBearer = true) => {
    return isAuth ? (0, exports.AccessAuthHeaderObservable)(headers, withBearer) : (0, rxjs_1.of)(headers);
};
exports.processAccessNetworkHeader = processAccessNetworkHeader;
/**
 * @deprecated
 * 使用NetworkHelp代替
 */
const AccessAndSpotAuthHeaderObservable = (headers) => {
    return (0, dataRetrive_1.getTradeDependencyInstance)()
        .getTradingToken()
        .pipe((0, operators_1.map)((tradingTokenInfo) => {
        if (!tradingTokenInfo) {
            throw Error_1.ErrorGenerate.generateError(Tools_1.TradeHttpErrorCode.TradeUnAuthorized, "trade_unAuthorized");
        }
        else {
            const authHeader = Object.assign(Object.assign({}, headers), { Authorization: `Bearer ${tradingTokenInfo.awsToken || ""}|${tradingTokenInfo.tradingToken || ""}` });
            return authHeader;
        }
    }));
};
exports.AccessAndSpotAuthHeaderObservable = AccessAndSpotAuthHeaderObservable;
/**
 * @deprecated
 * 使用NetworkHelp代替
 */
const AccessAndTraderAuthHeaderObservable = (headers) => {
    return (0, dataRetrive_1.getTradeDependencyInstance)()
        .getTradingToken()
        .pipe((0, operators_1.map)((tradingTokenInfo) => {
        if (!tradingTokenInfo) {
            throw Error_1.ErrorGenerate.generateError(Tools_1.TradeHttpErrorCode.TradeUnAuthorized, "trade_unAuthorized");
        }
        else if (!tradingTokenInfo.traderToken) {
            throw Error_1.ErrorGenerate.generateError(Tools_1.TradeHttpErrorCode.traderUnAuthorized, "trader_unAuthorized");
        }
        else {
            const authHeader = Object.assign(Object.assign({}, headers), { Authorization: `Bearer ${tradingTokenInfo.awsToken || ""}|${tradingTokenInfo.traderToken}` });
            return authHeader;
        }
    }));
};
exports.AccessAndTraderAuthHeaderObservable = AccessAndTraderAuthHeaderObservable;
/**
 * @deprecated
 * 使用NetworkHelp代替
 */
const FullTokenAuthHeaderObservable = (headers) => {
    return (0, dataRetrive_1.getTradeDependencyInstance)()
        .getTradingToken()
        .pipe((0, operators_1.map)((tradingTokenInfo) => {
        if (!tradingTokenInfo) {
            throw Error_1.ErrorGenerate.generateError(Tools_1.TradeHttpErrorCode.TradeUnAuthorized, "auth_unAuthorized");
        }
        else {
            const authHeader = Object.assign(Object.assign({}, headers), { Authorization: `Bearer ${tradingTokenInfo.awsToken || ""}|${tradingTokenInfo.tradingToken || ""}|${tradingTokenInfo.swapToken || ""}|${tradingTokenInfo.traderToken || ""}` });
            return authHeader;
        }
    }));
};
exports.FullTokenAuthHeaderObservable = FullTokenAuthHeaderObservable;
